import type { PropsWithChildren, Ref } from "react";
import AddIcon from "@mui/icons-material/AddRounded";
import { Box, Typography } from "@mui/material";
import { DEFAULT_AREA_FIELD_ITEM_HEIGHT } from "./AreaFieldsHelper.ts";

interface Props {
  ref?: Ref<HTMLDivElement>;
  onDragEnter?: () => void;
  onAddField?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
}

export const AddField = ({ ref, onDragEnter, onAddField, disabled = true, children }: PropsWithChildren<Props>) => {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        height: `${DEFAULT_AREA_FIELD_ITEM_HEIGHT}px`,
        border: "1px dashed #E5E6E9",
        borderRadius: "2px",
        boxSizing: "border-box",
        color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
        cursor: disabled ? "default" : "pointer",
        alignItems: "center",
        pl: 0.5,
        gap: 0.5,
        ...(!disabled && {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
            borderStyle: "solid",
          },
        }),
      })}
      onDragEnter={onDragEnter}
      onClick={disabled ? undefined : onAddField}
      ref={ref}
    >
      <AddIcon color={disabled ? "disabled" : "action"} />
      <Typography variant="caption">{children ?? "Add Field..."}</Typography>
    </Box>
  );
};

export default AddField;
